var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCasperReply = function SvgCasperReply(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C11.5523 0 12 0.383756 12 0.857142V3.71428C12 5.45003 10.3584 6.85714 8.33333 6.85714H3.26055L5.07327 8.56627C5.44478 8.91655 5.41466 9.45865 5.00601 9.77708C4.59735 10.0955 3.9649 10.0697 3.59339 9.71943L0.26006 6.57657C-0.0866866 6.24964 -0.0866866 5.75035 0.26006 5.42342L3.59339 2.28056C3.9649 1.93029 4.59735 1.90447 5.00601 2.22291C5.41466 2.54134 5.44478 3.08344 5.07327 3.43372L3.26055 5.14285H8.33333C9.25381 5.14285 10 4.50326 10 3.71428V0.857142C10 0.383756 10.4477 0 11 0Z",
    fill: "#803DDF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCasperReply, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/casper_reply.633a8abd.svg";
export { ForwardRef as ReactComponent };